import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  server: {
    NODE_ENV: z.enum(['development', 'staging', 'production']).default('development'),
    VERCEL_ENV: z.enum(['development', 'preview', 'production']).default('development'),
    DATABASE_URI: z.string(),
    PAYLOAD_SECRET: z.string(),
    CRON_SECRET: z.string(),
    S3_BUCKET: z.string(),
    S3_ACCESS_KEY_ID: z.string(),
    S3_SECRET_ACCESS_KEY: z.string(),
    S3_REGION: z.string().regex(/^[a-z]{2}-[a-z]{4,9}-[1-9]$/, {
      message: 'S3_REGION must be a valid AWS region (e.g. us-east-1)',
    }),
    STRIPE_DONATION_SECRET_KEY: z.string(),
    STRIPE_MEMBERSHIP_SECRET_KEY: z.string(),
    STRIPE_DONATION_WEBHOOK_SECRET: z.string(),
    STRIPE_MEMBERSHIP_WEBHOOK_SECRET: z.string(),
    SMTP_HOST: z.string(),
    SMTP_USER: z.string(),
    SMTP_PASS: z.string(),
    ADMIN_NOTIFICATION_EMAIL: z.string(),
    LUMA_OFFICIAL_API_KEY: z.string(),
    LUMA_UNOFFICIAL_API_KEY: z.string(),
    LUMA_OFFICIAL_WEBHOOK_SECRET: z.string(),
    LUMA_UNOFFICIAL_WEBHOOK_SECRET: z.string(),
    LUMA_OFFICIAL_CALENDAR_ID: z.string(),
    LUMA_UNOFFICIAL_CALENDAR_ID: z.string(),
    PASSKIT_SIGNER_CERT_BASE64: z.string(),
    PASSKIT_SIGNER_KEY_BASE64: z.string(),
    PASSKIT_WWDR_BASE64: z.string(),
    YOUTUBE_API_KEY: z.string(),
    BILLTRACK50_KEY: z.string(),
    GOOGLE_ADDRESS_VALIDATION_API_KEY: z.string(),
  },
  client: {
    NEXT_PUBLIC_SERVER_URL: z.string(),
    NEXT_PUBLIC_STRIPE_MEMBERSHIP_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_STRIPE_DONATION_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string(),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    VERCEL_ENV: process.env.VERCEL_ENV,
    DATABASE_URI: process.env.DATABASE_URI,
    PAYLOAD_SECRET: process.env.PAYLOAD_SECRET,
    CRON_SECRET: process.env.CRON_SECRET,
    S3_BUCKET: process.env.S3_BUCKET,
    S3_ACCESS_KEY_ID: process.env.S3_ACCESS_KEY_ID,
    S3_SECRET_ACCESS_KEY: process.env.S3_SECRET_ACCESS_KEY,
    S3_REGION: process.env.S3_REGION,
    STRIPE_MEMBERSHIP_SECRET_KEY: process.env.STRIPE_MEMBERSHIP_SECRET_KEY,
    STRIPE_DONATION_SECRET_KEY: process.env.STRIPE_DONATION_SECRET_KEY,
    STRIPE_DONATION_WEBHOOK_SECRET: process.env.STRIPE_DONATION_WEBHOOK_SECRET,
    STRIPE_MEMBERSHIP_WEBHOOK_SECRET: process.env.STRIPE_MEMBERSHIP_WEBHOOK_SECRET,
    NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
    NEXT_PUBLIC_STRIPE_DONATION_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_STRIPE_DONATION_PUBLISHABLE_KEY,
    NEXT_PUBLIC_STRIPE_MEMBERSHIP_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_STRIPE_MEMBERSHIP_PUBLISHABLE_KEY,
    SMTP_HOST: process.env.SMTP_HOST,
    SMTP_USER: process.env.SMTP_USER,
    SMTP_PASS: process.env.SMTP_PASS,
    ADMIN_NOTIFICATION_EMAIL: process.env.ADMIN_NOTIFICATION_EMAIL,
    LUMA_OFFICIAL_API_KEY: process.env.LUMA_OFFICIAL_API_KEY,
    LUMA_UNOFFICIAL_API_KEY: process.env.LUMA_UNOFFICIAL_API_KEY,
    LUMA_OFFICIAL_WEBHOOK_SECRET: process.env.LUMA_OFFICIAL_WEBHOOK_SECRET,
    LUMA_UNOFFICIAL_WEBHOOK_SECRET: process.env.LUMA_UNOFFICIAL_WEBHOOK_SECRET,
    LUMA_OFFICIAL_CALENDAR_ID: process.env.LUMA_OFFICIAL_CALENDAR_ID,
    LUMA_UNOFFICIAL_CALENDAR_ID: process.env.LUMA_UNOFFICIAL_CALENDAR_ID,
    PASSKIT_SIGNER_CERT_BASE64: process.env.PASSKIT_SIGNER_CERT_BASE64,
    PASSKIT_SIGNER_KEY_BASE64: process.env.PASSKIT_SIGNER_KEY_BASE64,
    PASSKIT_WWDR_BASE64: process.env.PASSKIT_WWDR_BASE64,
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    YOUTUBE_API_KEY: process.env.YOUTUBE_API_KEY,
    BILLTRACK50_KEY: process.env.BILLTRACK50_KEY,
    GOOGLE_ADDRESS_VALIDATION_API_KEY: process.env.GOOGLE_ADDRESS_VALIDATION_API_KEY,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
})
